import authService from '../services/authService';
import { navigatorUiLoggerFor } from './logger';

export const navigatorUiLogger = navigatorUiLoggerFor()({
  loggerUrl: 'https://cftqmn5ilc.execute-api.us-east-1.amazonaws.com/prod/v1/log',
  stage: 'beta',
  region: 'us-east-1',
  token: authService.currentIdToken,
});
